import type { DraggableSyntheticListeners } from '@dnd-kit/core';
import cn from 'classnames';
import { Children, forwardRef } from 'react';

import { Drag } from '@webapp/common/assets/icons';

import css from './sortable.css';

export const SortableHandler = forwardRef<
    HTMLDivElement,
    {
        children?: ReactNode;
        className?: string;
        big?: boolean;
        iconStyle?: CSSProperties;
        extraStyle?: CSSProperties;
        extraClassName?: string;
        listeners?: DraggableSyntheticListeners;
        withListeners?: boolean;
    }
>(({ children, className, extraClassName, extraStyle, iconStyle, listeners, withListeners, big }, ref) => (
    <div
        className={cn(
            css.handler,
            'handler',
            { [css.useHandle]: ref, [css.withListeners]: withListeners, [css.big]: big },
            className,
        )}
    >
        <div className={css.handle} ref={ref} {...listeners}>
            <Drag className={css.drag} style={iconStyle} />
        </div>
        {Children.count(children) > 0 ? (
            <p className={cn(css.extra, extraClassName)} style={extraStyle}>
                {children}
            </p>
        ) : null}
    </div>
));
SortableHandler.displayName = 'SortableHandler2';
